
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/code-of-ethics",
      function () {
        return require("private-next-pages/code-of-ethics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/code-of-ethics"])
      });
    }
  